import {
    computeBrushParametrics,
    computeBrushRadiusAtMousePosition,
    createParametrics,
    initStateFromFeatures,
    initStateFromRoadworkFeatures,
} from "../utils"

export let StabiloMode = {}

// When the mode starts this function will be called.
// The value returned should be an object and will be passed to all other lifecycle functions
StabiloMode.onSetup = function (opts) {
    var state = {}

    state.roadSegments = opts.roadSegments
    state.startingFeatures = opts.startingFeatures

    this.map["dragPan"].disable()
    this.map.getCanvas().style.cursor = "url(assets/resources/circle_cursor.png) 32 32, pointer"

    const currentFeatures = opts.drawFeatures || []

    if (currentFeatures.length || opts.hasBeenUpdated) {
        state.parametricSegments = []
        state.featureIds = []

        initStateFromFeatures(state, currentFeatures)
    } else {
        const defaultParametrics = initStateFromRoadworkFeatures(state)
        createParametrics(this, state, defaultParametrics)
    }

    return state
}

StabiloMode.onDrag = function (state, e) {
    if (this.map && state.roadSegments) {
        const brushRadius = computeBrushRadiusAtMousePosition(this, e)

        const paintedParametrics = computeBrushParametrics(state, brushRadius, e)

        if (paintedParametrics.length) {
            const featuresUpdated = createParametrics(this, state, paintedParametrics)

            if (featuresUpdated) {
                this.map.fire("draw.paint_updated")
            }
        }
    }
}

StabiloMode.onMouseDown = function (state, e) {
    this.onDrag(state, e)
}

StabiloMode.toDisplayFeatures = function (state, geojson, display) {
    display(geojson)
}

StabiloMode.onTrash = function (state) {
    const defaultParametrics = initStateFromRoadworkFeatures(state)
    createParametrics(this, state, defaultParametrics)
}